module.exports = __webpack_public_path__ + "img/header-weddingRingsPolar.550c8c1.jpg";